<template>
    <div class='index'>
        <div class="content">
            <h4>快康服务协议</h4>
            <pre class="precla">
一、总则
1、快康信息科技有限公司作为健康交流互通平台为您提供相关技术服务。为确保您能正常地使用快康的服务，您应当阅读并遵守《快康服务协议》（以下简称“本协议”）。请您务必审慎阅读、充分理解各条款内容，特别是免除或限制责任的相应条款，以及开通或使用某项服务的单独协议，如您点击勾选即视为您同意并接受协议条款内容。本协议中的网站指快康网站及应用程序。本协议由网站的使用者（以下简称“您”）与快康网站运营方共同签订。
2、除非您已阅读并接受本协议所有条款，否则您无权使用快康的服务（以下简称“本服务”）。您同意接受更新后的本协议条款；如您不同意本协议的更新或修订，请您立即停止使用快康的任何服务。当您与本网站发生争议时，应以最新的服务协议为准。
3、快康在此特别提醒您，在您使用注册前请确认您已确实仔细阅读了本协议，如果您对本协议的任何条款或者将来随时可能修改、补充的条款有异议，您可选择不注册成为快康的用户或不再继续使用快康的任何服务。
4、您在进行注册程序过程中，根据声音、文字或图形提示可以选择表示“同意”的操作，当您点选“同意”按钮时即视为您已仔细阅读本协议，同意接受本协议项下的所有条款，包括接受快康对本协议条款随时所做的任何修改，并愿意受其约束。
5、您在快康咨询、提问、搜索、提供医疗健康信息、与其它用户交流及其他健康类服务，即代表您已经同意本协议。
6、本协议的条款适用于快康提供的各种服务，但当您使用快康某一特定服务时，如该服务另有单独的服务条款、指引或规则，您应遵守本协议及快康不时公布的与该服务相关的服务条款、指引或规则等。前述所有的指引和规则，均构成本协议的一部分。除非本协议另有其他明示规定，新推出的产品或服务、增加或强化目前本服务的任何新功能，均受到本协议之规范。

二、服务简介
1、快康作为健康交流互通平台仅向正规医疗机构的健康领域专家提供相关服务。因此，您必须是经合法登记、已获得相应执业证书或具有同等资质人士。若不符合本项条件，请勿使用本服务，快康可随时自行全权决定拒绝向任何人士提供本服务。本服务不会提供给被暂时或永久中止资格的本网站会员。
2、您应保证：提供详尽、真实、准确和完整的个人资料。如果资料发生变动，您应及时更改。若您提供任何错误、不实、过时或不完整的资料，并为快康所确知；或者快康有合理理由怀疑前述资料为错误、不实、过时或不完整的资料，快康有权暂停或终止您的账号，并拒绝现在或将来使用本服务的全部或一部分。在此情况下，您可通过快康的申诉途径与快康取得联系并修正个人资料经快康核实后恢复账号使用。此外，按照相关法律法规，您应保证，您仅向其提供医疗咨询服务。

三、服务暂停、变更与中止条款
1、鉴于移动互联网服务的特殊性，快康有权随时变更、中断或终止部分或全部的服务。如变更、中断或终止的服务属于免费服务，快康无需通知您，也无需对任何您或任何第三方承担任何责任。
2、您理解，快康需要定期或不定期地对提供本服务的平台或相关的设备进行检修或者维护，如因此类情况而造成本服务在合理时间内的中断，快康无需为此承担任何责任，但快康应尽可能事先进行通告。
3、如发生下列任何一种情形，快康有权随时中断或终止向您提供本协议项下的服务而无需对您或任何第三方承担任何责任：
（1)您提供的个人资料不真实；
（2)您违反本协议中的规定；
（3)您违反快康发布的政策；
（4)快康认为其他不适宜的地方。

四、您的账号、密码和安全性
1、您一旦注册成功，成为快康的合法用户，将得到一个您的帐号和密码。您的帐号和密码由您负责保管。您应当对任何以您账号进行的所有活动和事件负全责，且您有权随时根据指示更改您的密码。若发现任何非法使用您的帐号或存在安全漏洞的情况，请立即通知快康。
2、因黑客行为或您的保管疏忽等情况导致账号、密码遭他人非法使用，快康不承担责任。为向您提供本服务，您同意并授权快康将您在注册、使用本服务过程中提供、形成的信息传递给为您提供您所要求的产品和服务、而必须和第三方分享您的个人信息，向您提供其他服务的第三方，或从提供其他服务的第三方获取您在注册、使用其他服务期间提供、形成的信息。快康将根据法律法规的要求，履行其作为移动互联网信息服务提供者应当履行的义务。

五、个人信息授权条款
1、保护您隐私是快康的一项基本政策，快康保证不对外公开或向第三方提供您的注册资料及您在使用本服务时存储在快康的非公开内容，但下列情况除外：
（1)事先获得您的明确授权；
（2)根据有关的法律法规要求；
（3)按照相关政府主管部门的要求；
（4)为维护社会公众的利益；
（5)为维护快康的合法权益。
2、快康可能会与第三方合作向您提供相关的网络服务或结算服务，在此情况下，您同意并授权快康将您的注册资料或个人信息等提供给该第三方。
3、若为您购买保险的，您同意快康收集和使用您的以下信息并传输给保险公司用于为您购买保险，信息包括：姓名、身份证号、手机号码、执业范围、执业类别、医生职称、执业证书编号、医院名称、医院级别等。
4、在不透露单个您隐私资料的前提下，您同意快康对整个您数据库进行分析并对您数据库进行商业上的利用，包括出售您数据库中的信息。
5、根据法律规定，我们将对您在平台上产生的咨询信息进行去标识化处理，确保数据接收方无法复原或重新识别个人信息主体，为了帮助更多用户，经您同意我们将展示前述信息至第三方阅读。如您不希望将您的匿名化和／或去标识化处理的信息展示给第三方，可以选择不公开。
6、对于您在享受服务过程中获得的第三方的信息或资料（包括但不限于用户信息、用户健康资料以及用于存储在快康的仅向您公开的内容），您仅能用于解决该用户问题、在用户同意的特定事项中或用户的授权范围内使用。您不得用于其它用途、向其它第三方进行公开、透露或授权其它第三方进行使用。
7、您知悉并同意：您的有关个人信息将可能被用于在快康旗下的平台上，展示信息包括但不限于：肖像、姓名、职称、医院、科室、擅长疾病或用户评价等。
8、您可选择是否授权我们收集和使用您的个人信息的情形
为提升您在快康平台上的操作体验，我们的以下附加功能中可能会收集和使用您的个人信息。如果您不提供这些个人信息，您依然可以在平台上提供咨询服务，但您可能无法使用这些可以为您所带来更多便捷的附加功能或在每一次提供咨询服务时需要重复填写一些信息。
这些附加功能包括：
（1)基于位置信息的个性化推荐功能：我们会收集您的位置信息（我们仅收集您当时所处的地理位置，但不会将您各时段的位置信息进行结合以判断您的行踪轨迹）来判断您所处的地点，自动为您所在区域的用户推荐您的服务。 
（2)基于摄像头（相机）的附加功能：您可以使用这个附加功能完成视频拍摄、拍照、扫码以及人脸识别登录的功能。当您使用人脸识别登录时我们会收集您的面部信息。未来我们可能会将人脸识别技术应用于更多场景，但那时我们会再次与您确认您是否愿意我们使用您的面部信息来实现这些附加功能。
（3)基于图片上传的附加功能：您可以在快康上传您的照片来完善您的个人头像信息展示；
（4)基于语音技术的附加功能：您可以直接使用麦克风来与用户进行语音交流。在这些功能中我们会收集您的录音内容以识别您处方需求和客服需求。

六、协议修改
快康有权在必要时修改本协议条款，协议条款一旦发生变动，届时将在您界面提示修改内容，该提示行为视为快康经通知您修改内容，如果您不同意所作的修改，可以主动取消获得的网络服务，进行注销。如果您继续享有快康提供的服务，则被视为接受协议变动。当发生有关争议时，以最新的服务协议为准。

七、特别授权
您完全理解并不可撤销地授予快康下列权利：
1、一旦您向快康作出任何形式的承诺，且相关机构已确认您违反了该承诺，则快康有权立即按您的承诺或协议约定的方式对您的账户采取限制措施，包括中止或终止向您提供服务，并公示相关机构确认的您的违约情况。您了解并同意，快康无须就相关违约事项与您核对事实，或另行征得您的同意，且快康无须就此限制措施或公示行为向您或任何第三方承担任何的责任。
2、一旦您违反本协议、或与快康签订其他协议的约定，快康有权以任何方式通知本服务或其他相关快康服务，要求其对您的权益采取限制措施，包括但不限于要求中止、终止对您提供的部分或全部服务，且在其经营或实际控制的网站或APP公示您的违约情况。
3、您授权快康通过您注册、使用本服务过程中形成的信息通过短信、邮件、电话或其他形式向您传送快康提供的服务。您同意接受快康通过短信、邮件、电话或其他形式向您发送活动、服务或其他相关商业信息。如果您不需要快康提供的部分或全部服务的活动、服务或其他相关商业信息的服务，在您向快康客服提出申请后予以中止、终止对您提供的该部分或全部服务。

八、快康拒绝提供担保或保证
1、您对移动网络服务的使用承担风险，并承担因为使用移动网络服务而产生的一切后果。您应对通过快康向任何其他网络用户提供的任何服务或咨询独立承担法律责任。快康对此不作任何类型的担保或保证，不论是明确的或隐含的，但是不对商业性的隐含担保、特定目的和不违反规定的适当担保或保证作限制。
2、快康不担保服务一定能完全满足您的要求，也不担保或保证各项服务不会受网络、通信等原因而中断，对服务的及时性、安全性、错误程序的发生都不作担保或保证。
3、快康对在平台上得到的任何有关健康的咨询意见等，不作担保或保证。

九、对您信息的存储和限制
1、快康对您使用网络服务而受到的任何直接、间接、偶然、特殊及继起的损害（快康违反法律、法规和本协议的条款除外）不负责任，这些损害可能来自：不正当使用网络服务，私自在网上进行交易，非法使用网络服务或您传送的信息有所变动。这些行为都有可能会导致快康的形象受损，所以快康事先提出这种损害的可能性。因发生如火灾、水灾、暴动、骚乱、战争、自然灾害等不可抗拒事故，快康所不能控制的事件而影响快康提供服务，快康无须承担任何责任。
2、快康不对您所发布信息的删除或储存失败负责。快康积极采用数据备份加密等措施保障您数据的安全，但不对由于因意外因素导致的数据损失和泄漏负责。快康有权审查和监督您的行为是否符合本协议的要求，如果您违背了本协议的约定，则快康有权中断您的服务。

十、用户管理
1、您同意严格遵守法律法规规章规定及执业医院管理规定，依法遵守以下义务：
（1)不得制作、传输或发表以下违法信息资料：反对宪法所确定的基本原则，煽动抗拒、破坏宪法和法律法规实施的；危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的，煽动推翻社会主义制度的；损害国家荣誉和利益的；歪曲、丑化、亵渎、否定英雄烈士事迹和精神，侵害英雄烈士的姓名、肖像、名誉、荣誉的；宣扬或煽动实施恐怖主义、极端主义及其活动的；煽动民族仇恨、民族歧视、破坏民族团结的言论；破坏国家宗教政策，宣扬邪教和封建迷信的；散布谣言，扰乱经济秩序和社会秩序的；散布淫秽、色情、暴力或者教唆犯罪的；侮辱或者诽谤他人，侵害他人名誉、隐私和其他合法权益的；法律、行政法规禁止的其他内容。
（2)防范和抵制制作、复制、发布含有下列内容的不良信息资料：标题严重夸张，发表内容与标题严重不符的；不当评述自然灾害、重大事故等灾难的；煽动人群歧视、地域歧视等的；宣扬低俗、庸俗、媚俗内容的；违反社会公德行为的；侵犯未成年人合法权益的；其他对网络生态造成不良影响的内容。
2、本协议依据国家相关法律法规规章制定，您亦同意严格遵守以下义务：
（1)从中国大陆向境外传输资料信息时必须符合中国有关法规；
（2)不得利用本网站从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；
（3)不得干扰本网站的正常运转，不得侵入本网站及国家计算机信息系统；
（4)不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的、不文明的等信息资料；
（5)不得教唆他人从事违法违规或本协议、平台规则所禁止的行为；
（6)不得利用在本网站注册的账户进行牟利性经营活动；
（7)不得发布任何侵犯他人个人信息、著作权、商标权等知识产权或合法权利的内容；
3、您须对自己在网上的言论和行为承担法律责任，您若在本网站上散布和传播反动、色情或其它违反国家法律的信息，本网站的系统记录有可能作为您违反法律的证据。
4、您在进行注册过程中，您的用户名注册与使用应符合网络道德，遵守中华人民共和国的相关法律法规。您的用户名和昵称中不能含有威胁、淫秽、谩骂、非法、侵害他人正当权益等有争议性的文字。您在快康上的言论不得违法、不得违反公序良俗、不得使用攻击性语言恶意中伤他人，或作出虚假性陈述。您保证您在快康上提供的信息的真实性、合法性和有效性。您单独承担在快康上发布内容的一切相关责任。您使用或提供的服务应遵守所有适用于快康的地方法律、国家法律和国际法律标准。
5、您使用本服务不作其他非法用途。
6、您不得干扰或扰乱本服务。特别是，您不得以任何形式转让或授权他人使用自己的快康账户，亦不得盗用他人账号，并对由此行为造成的后果自负。
7、您应遵守所有使用本服务的各项协议、规定、程序和惯例。您不能传输任何教唆他人构成犯罪行为的资料；不能传输助长国内不利条件和涉及国家安全的资料；不能传输任何不符合当地法规、国家法律和国际法律的资料。未经许可而非法进入其它电脑系统是禁止的。
8、您不得发布任何不基于事实、虚构、夸大、引人误解的信息；不得发布涉及政治、性别、种族歧视或攻击他人的文字、图片、视频或语言等信息；不得发布介绍个人、科室等广告性质的内容；不得有其它涉及违反当地法规、国家法律和国际法律的行为。
9、若您的行为不符合本协议的规定，快康有权做出独立判断，并立即停止向该您账号提供服务。您需对自己在网上的行为承担法律责任。您若在快康上散布和传播反动、色情或其他违反国家法律的信息，快康的系统记录有可能作为您违反法律的证据。

十一、保障
您同意保障和维护快康的利益，如果因为您违反有关法律、法规或本协议的任何规定而给快康或任何其他第三方造成任何损失，您同意承担由此产生的损害赔偿责任，其中包括快康为此而支付的律师费用。
十二、结束服务
您或快康可随时根据用户管理的规范（参见本协议的第十条）和实际情况中断一项或多项本服务，快康无需对您或任何其他第三方负责。您对本协议的修改有异议，或对快康的服务不满，可以行使如下权利。
1、停止使用快康提供的服务。
2、通告快康停止对该您账号的服务。结束您的服务后，您使用本服务的权利马上终止，即刻，快康不对您承担任何义务和责任。

十三、通告
1.本协议项下所有的通知均可通过重要页面公告、电子邮件或常规的信件传送等方式进行；该等通知于发送之日视为已送达。
2.您对于快康的通知应当通过快康对外正式公布的通信地址、电子邮件地址等联系信息进行邮寄书面送达。

十四、广告说明
1、快康上为您的便利而提供的外部链接，包括但不限于任何广告内容链接，以及该链接所指向网页之所有内容，均系该网页所属第三方快康的所有者制作和提供（以下简称“第三方网页”）。第三方网页并非也不反映快康之任何意见和主张，也不表示快康同意或支持该第三方网页上的任何内容、主张或立场。快康对第三方网页中内容之合法性、准确性、真实性、适用性、安全性和完整性等概不承担任何负责。任何单位或个人如需要第三方网页中内容（包括资讯、资料、消息、产品或服务介绍、报价等），并欲据此进行交易或其他行为前，应慎重辨别这些内容的合法性、准确性、真实性、适用性、完整性和安全性（包括下载第三方网页中内容是否会感染电脑病毒），并采取谨慎的预防措施。如您不确定这些内容是否合法、准确、真实、实用、完整和安全，建议您先咨询专业人士。
2、任何单位或者个人因相信、使用第三方网页中信息、服务、产品等内容，或据此进行交易等行为，而引致的人身伤亡、财产毁损（包括因下载而感染电脑病毒）、名誉或商誉诽谤、版权或知识产权等权利的侵犯等事件，及因该等事件所造成的损害后果，快康概不承担任何法律责任。无论何种原因，快康不对任何非与快康直接发生的交易和行为承担任何直接、间接、附带或衍生的损失和责任。

十五、网络服务的内容所有权
快康提供网络服务的内容包括：文字、软件、声音、照片、视频、录像、图表；网页、广告中的全部内容；电子邮件中的全部内容；快康为您提供的其他信息。所有这些信息均受版权、商标、标签和其他财产所有权法律的保护。未经相关权利人同意，上述资料均不得在任何媒体直接或间接发布、播放、出于播放或发布目的而改写或再发行，或者被用于其他任何商业目的。所有这些资料或资料的任何部分仅可作为私人和非商业用途而保存在某台计算机内。快康的所有内容版权归原文作者和快康共同所有，任何人需要转载快康的内容，必须获得原文作者或快康的明确授权。

十六、在线咨询服务条款
1、本服务条款只适用于申请开通在线咨询功能的健康领域专家（以下简称“您”）。在线咨询功能由快康与健康领域专家合作，通过互联网信息技术方便群众就医，提升健康服务。
2、您可用过快康提供的平台向用户提供符合相关法律法规的在线咨询服务，包括咨询、健康教育等在线服务。为充分保护您对与快康平台提供的各项服务的知情权，快康就其提供的各项服务的相关性、有效性以及限制性条款提供如下，快康在此特别提醒，您在使用注册前已确实仔细阅读了本“在线咨询服务条款”，快康可能随时修改本功能条款，条款变更或修改也可能通过本网站某些具体服务所制定的通告或协议条款列明。这些条款与您使用本功能密切相关，您在访问时应该进行了解，一旦使用本功能即表示您已经接受本功能协议，如果您对本功能协议的任何条款或者将来随时可能修改、补充的条款有异议，您可选择关闭在线咨询服务。
3、您在平台向用户提供咨询等与用户交流服务及其他健康类服务时，即代表您已经同意受本服务条款约束，且完全认可、接受快康的统一管理。
4、快康仅提供健康平台信息及技术，不对您的健康咨询行为及技术提供任何保证或担保。
5、在平台咨询过程中产生投诉、纠纷等，由快康按法律、法规调解处理。根据相应法律、法规，您有可能对违规行为承担相应责任。
6、平台按月与您结算在线咨询服务费。在每月结算日根据您在平台上咨询的考核，将您应得的服务费用汇至您的指定账户。
7、本网站有权按照平台所制定的服务费用结算规则执行。如结算规则有修改，平台将提前5个工作日以电子邮件或附件形式发送到您指定的电子邮箱地址，或同时通过网站平台等方式进行公示，您应及时查阅了解。

十七、法律
1、本协议之效力、解释、执行和争议的解决均适用中华人民共和国之法律。如本协议之任何一部分与中华人民共和国法律相抵触，则该部分条款应按有关法律规定重新解释，部分条款之无效或重新解释不影响其它条款之法律效力。
2、您和快康运营方一致同意凡因本协议所产生的纠纷双方应协商解决，协商不成任何一方可提交快康网站所有人所在地有管辖权的人民法院诉讼裁决。

				</pre>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        watch: {},
        computed: {},
        created() {},
        mounted() {},
        methods: {},
    };
</script>
<style lang="scss" scoped>
    .index {
        .content {
            background-color: #fff;
            padding: 20px;
            overflow: hidden;

            h4 {
                text-align: center;
                font-size: 25px;
            }

            .precla {
                white-space: pre-line;
                line-height: 20px;
                color: #333;
            }
        }
    }
</style>